import { LeftOrRightAlignment } from "@mcleod/core";
import { AbstractGeneratedColumnHandler } from "./AbstractGeneratedColumnHandler";
import { ToolsTableColumn } from "./ToolsTableColumn";
import { TableCell } from "./TableCell";
import { TableRow } from "./TableRow";
import { ToolsTableCell } from "./ToolsTableCell";

export class ToolsHandler extends AbstractGeneratedColumnHandler {
    protected override createColumn(): ToolsTableColumn {
        return new ToolsTableColumn({ table: this.table });
    }

    protected override get columnAlignment(): LeftOrRightAlignment {
        return this.table.toolsCellAlignment;
    }

    protected override getLogPath(): string {
        return "components.table.ToolsHandler";
    }

    protected override createPlaceholderCell(tableRow: TableRow): TableCell {
        return new ToolsTableCell({ table: this.table, row: tableRow });
    }
}
